import { __awaiter } from "tslib";
import axios from 'axios';
import { REBILLY_PUBLICKEYS, REBILLY_URLS } from './api';
export const createPaymentToken = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { sandbox } = params;
    const options = {
        headers: {
            Authorization: sandbox ? REBILLY_PUBLICKEYS.local : REBILLY_PUBLICKEYS.prod,
            'Content-Type': 'application/json',
        },
    };
    try {
        const response = yield axios.post(`${sandbox ? REBILLY_URLS.local : REBILLY_URLS.prod}/tokens`, params, options);
        const responseData = response.data;
        if (response.status !== 200 && responseData.invalidFields) {
            const invalidFieldMessage = responseData.invalidFields.map((field) => {
                return field.message;
            });
            responseData.message = invalidFieldMessage.join('/n');
            throw Error(responseData.message);
        }
        return responseData.id;
    }
    catch (ex) {
        const error = ex;
        if (error.response) {
            console.error(`createPaymentToken: ${JSON.stringify(error.response.data)}`);
        }
        throw ex;
    }
});
//# sourceMappingURL=createPaymentToken.js.map